(function () {
  var burger = document.querySelector('.burger');
  var mnav = document.querySelector('.mnav');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();

(function () {
  var main = document.querySelector('[data-pdp-main]');
  var thumbs = document.querySelectorAll('[data-pdp-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-src');
      if (src) main.setAttribute('src', src);
      thumbs.forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      btn.setAttribute('aria-current', 'true');
    });
  });
})();

(function () {
  var form = document.querySelector('[data-variant-form]');
  if (!form) return;

  var dataEl = document.querySelector('[data-variant-json]');
  if (!dataEl) return;

  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var idInput = form.querySelector('[data-variant-id]');
  var priceEl = document.querySelector('[data-price]');
  var submit = form.querySelector('[data-submit]');
  var err = document.querySelector('[data-pdp-err]');

  function selected() {
    var picks = [];
    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      picks.push(checked ? checked.value : null);
    });
    return picks;
  }

  function match(picks) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < picks.length; j++) {
        if (picks[j] === null || v.options[j] !== picks[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function update() {
    if (err) err.textContent = '';
    var picks = selected();
    if (picks.indexOf(null) !== -1) {
      if (submit) { submit.disabled = true; submit.textContent = 'Select options'; }
      return;
    }
    var v = match(picks);
    if (!v) {
      if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
      if (err) err.textContent = 'That combination is not available.';
      return;
    }
    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (submit) {
      submit.disabled = !v.available;
      submit.textContent = v.available ? 'Add to bag' : 'Sold out';
    }
  }

  form.addEventListener('change', update);
  update();
})();
